import {
  Center,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Input,
  useColorModeValue,
  Button,
  useToast,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { ViewIcon } from '@chakra-ui/icons';
import moment from 'moment';
import MultiSelect from 'components/autocomplete/autocomplete';
// Custom components
import TableWrapper from 'components/tableWrapper/tableWrapper';
import { Modules, LockerLedgerStatus } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import GlobalLockersApi from 'api/globallockers';
import PageError from 'components/nopermission/PageError';
import { MdArrowForward } from 'react-icons/md';

//Remove when API sends Data
export default function CheckTable(props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  //Data Fetching
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [filterDate, setFilterDate] = useState(0);
  const { getPermissionsForModule } = usePermissions();
  const [lockersPermissions, setLockersPermissions] = useState(null);
  const [fetchLockerListError, setFetchLockerListError] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const debounceTimeout = useRef(null); // Store debounce timeout

  const handleDebouncedStartDate = (value) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      setFilterStartDate(value); // Update state after debounce
    }, 800); // Debounce delay
  };

  const handleDebouncedEndDate = (value) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      setFilterEndDate(value); // Update state after debounce
    }, 800); // Debounce delay
  };

  const selectedStatusTypeValue = Array.isArray(selectedStatusType)
    ? selectedStatusType?.map((option) => option.value).join(',')
    : selectedStatusType.value;

  const FetchLockerList = async () => {
    try {
      setLoading(true);
      let response = await GlobalLockersApi.List({
        currentPage,
        itemsPerPage,
        is_active: true,
        // sort: 'name:asc',
        searchTerm,
        selectedStatusTypeValue,
        filterStartDate,
        filterEndDate,
      });
      response = response.data;
      console.log('Response from GlobalLockersApi', response);
      setLoading(false);
      if (response.status_code === 200) {
        setFetchLockerListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchLockerListError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchLockerListError(true);
      console.log(err);
      setList([]);
    }
  };

  useEffect(() => {
    const lockersPermissions = getPermissionsForModule([Modules.Lockers]);
    setLockersPermissions(lockersPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (lockersPermissions?.read) {
      FetchLockerList();
    }
  }, [
    lockersPermissions,
    searchTerm,
    currentPage,
    selectedStatusTypeValue,
    filterStartDate,
    filterEndDate,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedStatusTypeValue, filterStartDate, filterEndDate]);

  const handleSearch = async (search) => {
    setSearchTerm(search);
    setCurrentPage(1); // Reset currentPage to 1 on each search
  };

  // console.log('List conatis', list);

  if (!lockersPermissions?.read) {
    return <NoPermissionsMessage module={Modules.Lockers} />;
  }

  return fetchLockerListError ? (
    <PageError />
  ) : (
    <>
      <Flex
        mt='8rem'
        px='25px'
        justify='left'
        mb='20px'
        align='center'>
        <Flex
          direction='column'
          gap={4}
          pt={5}>
          <Flex
            direction={{ base: 'column', '2xl': 'row' }}
            gap={4}>
            <Flex
              direction={{ base: 'column', md: 'row' }}
              gap={4}>
              {/* <Flex>
                <Input
                  variant='auth'
                  type='text'
                  minWidth='150px'
                  placeholder='Search ...'
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </Flex> */}
            </Flex>
            <Flex>
              <MultiSelect
                options={LockerLedgerStatus}
                placeholder='Select Status'
                value={selectedStatusType}
                onChange={setSelectedStatusType}
                isMulti={true}
              />
            </Flex>
            <Flex
              direction={{ base: 'column', md: 'row' }}
              gap={2}>
              <Flex gap={2}>
                <Center>From</Center>
                <Input
                  // variant='auth'
                  placeholder='Start Date'
                  type='date'
                  max={filterEndDate || today} // Restrict to end date or today, whichever is earlier
                  value={filterStartDate}
                  onChange={(e) => handleDebouncedStartDate(e.target.value)} // Debounce the update
                />
              </Flex>
              <Flex gap={2}>
                <Center>to</Center>
                <Input
                  // variant='auth'
                  placeholder='End Date'
                  type='date'
                  min={filterStartDate} // Ensure the end date is not before the start date
                  max={today} // Prevent selection of future dates
                  value={filterEndDate}
                  onChange={(e) => handleDebouncedEndDate(e.target.value)} // Debounce the update
                />
              </Flex>
            </Flex>
          </Flex>
          {/* <AddModal
            Icon={<AddIcon />}
            head={'Add Customer Admin User'}
            func={FetchOrderList}
          /> */}
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr /* bgColor='yellow' */>
              {/* <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Code
                </Flex>
              </Th> */}
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Gold Weight
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Price / Gram
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Amount
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Advance Amount
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Transaction Date
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  User
                </Flex>
              </Th>

              <Th
                pe='25px'
                borderColor={borderColor}>
                <Flex
                  justifyContent='center'
                  // backgroundColor='red'
                  width='100%'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  {/* <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.code}
                      </Text>
                    </Flex>
                  </Td> */}
                  <Td>
                    <Flex
                      minW='90px'
                      align='center'>
                      {obj.transaction_type === 'CREDIT' ? (
                        <Text
                          me='10px'
                          color='green'
                          fontSize='sm'
                          fontWeight='700'>
                          + {isNaN(parseFloat(obj.weight)) ? 'N/A' : parseFloat(obj.weight).toFixed(3)} gms
                        </Text>
                      ) : obj.transaction_type === 'DEBIT' ? (
                        <Text
                          me='10px'
                          color='red'
                          fontSize='sm'
                          fontWeight='700'>
                          - {isNaN(parseFloat(obj.weight)) ? 'N/A' : parseFloat(obj.weight).toFixed(3)} gms
                        </Text>
                      ) : (
                        <Text
                          me='10px'
                          fontSize='sm'
                          fontWeight='700'>
                          {isNaN(parseFloat(obj.weight)) ? 'N/A' : parseFloat(obj.weight).toFixed(3)} gms
                        </Text>
                      )}
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        Rs {obj.gold_price}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        Rs {obj.amount}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        Rs {obj.extra_amount}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {moment(obj.date_of_payment).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {
                          LockerLedgerStatus.find(
                            (option) => option.value === obj?.status
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                 
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.user_name}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex
                      // bgColor='red'
                      justifyContent='center'>
                      {/* <EditModal
                          Icon={<EditIcon />}
                          head={'Update Customer Admin User'}
                          func={FetchOrderList}
                          currentUser={obj}
                        /> */}
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/order/${obj.order_id}`,
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                      {/* {obj.is_active === true ? (
                        <PopDelete
                          Icon={<DeleteIcon />}
                          button={
                            <Button
                              colorScheme='red'
                              onClick={handleDelete}
                              value={obj.id}>
                              Delete
                            </Button>
                          }
                        />
                      ) : (
                        'Disabled'
                      )} */}
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </>
  );
}
